module.exports = __webpack_public_path__ + "img/MAC1100_L.fa5021aa.png";